module.exports = __webpack_public_path__ + "static/media/left.a8261743.jpg";